export default "/_next/static/sounds/uv_scanner-5ae00fed1ecffbb45eca83d29f5b4373.mp3";